import { themeAtom } from "@/features/app-layout/atoms/theme-atoms"
import { cn } from "@/lib/utils"
import { useAtomValue } from "jotai"
import { motion } from "motion/react"

type Props = {
  user: "assistant" | "client",
  children: React.ReactNode
}

const ChatCard = ({ user, children }: Props) => {

  const theme = useAtomValue(themeAtom)

  return (
    <motion.div

      initial={{
        opacity: 0,
        y: 50,
      }}
      animate={{
        opacity: 1,
        y: 0,
      }}
      exit={{
        opacity: 0,
        y: -50,
      }}
      transition={{
        duration: 0.6,
        ease: [0.4, 0.0, 0.2, 1],
      }}
      className={cn("w-full h-auto relative bg-white bg-clip-padding backdrop-filter p-4 sm:p-6 backdrop-blur-xl bg-opacity-80 backdrop-saturate-100 shadow-[-1px_4px_12px_-3px_rgba(236,_72,_153,_0.5)] backdrop-contrast-150 rounded-3xl",
      user === "client" ? "py-2 sm:py-3" : "py-3 sm:py-6")}
    >
      <div className={cn("absolute hidden sm:flex items-center justify-center top-2 lg:top-0  bg-white size-10 xl:size-14 rounded-full",
        user === "assistant" ? "-left-12 xl:-left-20" : "-right-12 xl:-right-20"
      )}>
        <img className="w-7 xl:w-10 h-auto" src={user === "client" ? theme.avatar : "https://86v8u6agau.ufs.sh/f/A17KOoeuO4h9PTzzkJB6Kayu3FZoPe1vCJnV7chgTXlAdkMp"} />
      </div>
      {children}
    </motion.div>
  )
}

export default ChatCard;

